webpackJsonp([212406790991065],{

/***/ 575:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(25);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactstrap = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LinkButton = function LinkButton(_ref) {
	  var text = _ref.text,
	      to = _ref.to,
	      isExternal = _ref.isExternal,
	      style = _ref.style;
	
	  if (isExternal) {
	    return _react2.default.createElement(
	      'a',
	      { href: to, target: '_blank' },
	      _react2.default.createElement(
	        StyledButton,
	        null,
	        text
	      )
	    );
	  }
	  return _react2.default.createElement(
	    StyledButton,
	    { tag: _gatsbyLink2.default, to: to },
	    text
	  );
	};
	
	LinkButton.propTypes = {
	  text: _propTypes2.default.string.isRequired,
	  to: _propTypes2.default.string.isRequired,
	  isExternal: _propTypes2.default.bool
	};
	
	// inline Component to "Style" the button (with hover)
	
	var StyledButton = function (_React$Component) {
	  _inherits(StyledButton, _React$Component);
	
	  function StyledButton(props) {
	    _classCallCheck(this, StyledButton);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      hover: false
	    };
	
	    _this.toggleHover = _this.toggleHover.bind(_this);
	    return _this;
	  }
	
	  StyledButton.prototype.toggleHover = function toggleHover() {
	    this.setState({ hover: !this.state.hover });
	  };
	
	  StyledButton.prototype.render = function render() {
	    var children = this.props.children;
	    var hover = this.state.hover;
	
	
	    var hoverStyle = void 0;
	    if (hover) {
	      hoverStyle = {
	        backgroundColor: 'lightblue',
	        borderColor: 'lightblue'
	      };
	    }
	
	    return _react2.default.createElement(
	      _reactstrap.Button,
	      {
	        style: _extends({
	          backgroundColor: '#1EAAE5',
	          borderColor: '#1EAAE5'
	        }, hoverStyle),
	        onMouseEnter: this.toggleHover,
	        onMouseLeave: this.toggleHover
	      },
	      children
	    );
	  };
	
	  return StyledButton;
	}(_react2.default.Component);
	
	exports.default = LinkButton;
	module.exports = exports['default'];

/***/ }),

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LinkButton = undefined;
	
	var _LinkButton = __webpack_require__(575);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.LinkButton = _LinkButton2.default;

/***/ }),

/***/ 587:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyImage = __webpack_require__(18);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactMedia = __webpack_require__(21);
	
	var _reactMedia2 = _interopRequireDefault(_reactMedia);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Avantages = function Avantages(_ref) {
	  var title = _ref.title,
	      contentHTML = _ref.contentHTML,
	      image = _ref.image;
	
	  return _react2.default.createElement(
	    'div',
	    { style: { backgroundColor: '#f5f5f5' } },
	    _react2.default.createElement(
	      'div',
	      { style: { padding: '30px 0 30px 0' }, className: 'container' },
	      _react2.default.createElement(
	        'center',
	        null,
	        _react2.default.createElement(
	          'h3',
	          { style: { fontWeight: 'bold', marginBottom: 20 } },
	          title
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-6' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(_gatsbyImage2.default, { alt: image.title, sizes: image.sizes })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-6' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	              _reactMedia2.default,
	              { query: { minWidth: 992 } },
	              function (matches) {
	                return matches ? _react2.default.createElement('div', {
	                  style: {
	                    marginBottom: 30,
	                    fontFamily: 'Roboto',
	                    fontSize: 18,
	                    textAlign: 'justify',
	                    color: '#787878',
	                    position: 'absolute',
	                    top: '50%',
	                    transform: 'translateY(-50%)'
	                  },
	                  dangerouslySetInnerHTML: { __html: contentHTML }
	                }) : _react2.default.createElement('div', {
	                  style: {
	                    marginBottom: 30,
	                    fontFamily: 'Roboto',
	                    fontSize: 18,
	                    textAlign: 'justify',
	                    color: '#787878'
	                  },
	                  dangerouslySetInnerHTML: { __html: contentHTML }
	                });
	              }
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	Avantages.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  contentHTML: _propTypes2.default.string.isRequired,
	  image: _propTypes2.default.object.isRequired
	};
	
	exports.default = Avantages;
	module.exports = exports['default'];

/***/ }),

/***/ 588:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Gamme = function Gamme(_ref) {
	  var title = _ref.title;
	
	  return _react2.default.createElement(
	    'div',
	    { style: { padding: '30px 0 30px 0' } },
	    _react2.default.createElement(
	      'center',
	      null,
	      _react2.default.createElement(
	        'h3',
	        { style: { fontWeight: 'bold', marginBottom: 20 } },
	        title
	      )
	    )
	  );
	};
	
	Gamme.propTypes = {
	  title: _propTypes2.default.string.isRequired
	};
	
	exports.default = Gamme;
	module.exports = exports['default'];

/***/ }),

/***/ 589:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyImage = __webpack_require__(18);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactMedia = __webpack_require__(21);
	
	var _reactMedia2 = _interopRequireDefault(_reactMedia);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Intro = function (_React$Component) {
	  _inherits(Intro, _React$Component);
	
	  function Intro(props) {
	    _classCallCheck(this, Intro);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      contentHeight: 0,
	      imageHeight: 0
	    };
	    return _this;
	  }
	
	  Intro.prototype.componentDidMount = function componentDidMount() {
	    var contentHeight = this.divContent.clientHeight;
	    var imageHeight = this.divImage.clientHeight;
	    this.setState({ contentHeight: contentHeight, imageHeight: imageHeight });
	  };
	
	  Intro.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        title = _props.title,
	        contentHTML = _props.contentHTML,
	        image = _props.image;
	    var _state = this.state,
	        contentHeight = _state.contentHeight,
	        imageHeight = _state.imageHeight;
	
	
	    var centerStyle = void 0;
	    if (contentHeight) {
	      centerStyle = contentHeight <= imageHeight ? {
	        position: 'absolute',
	        top: '50%',
	        transform: 'translateY(-50%)'
	      } : {};
	    }
	
	    var contentStyle = _extends({
	      marginBottom: 30,
	      fontFamily: 'Roboto',
	      fontSize: 18,
	      textAlign: 'justify',
	      color: '#787878'
	    }, centerStyle);
	
	    return _react2.default.createElement(
	      'div',
	      { style: { paddingBottom: 30 }, className: 'container' },
	      _react2.default.createElement(
	        'center',
	        null,
	        _react2.default.createElement(
	          'h3',
	          { style: { fontWeight: 'bold', marginBottom: 20 } },
	          title
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-6' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	              _reactMedia2.default,
	              { query: { minWidth: 992 } },
	              function (matches) {
	                return matches ? _react2.default.createElement('div', {
	                  ref: function ref(divContent) {
	                    return _this2.divContent = divContent;
	                  },
	                  style: contentStyle,
	                  dangerouslySetInnerHTML: { __html: contentHTML }
	                }) : _react2.default.createElement('div', {
	                  ref: function ref(divContent) {
	                    return _this2.divContent = divContent;
	                  },
	                  style: contentStyle,
	                  dangerouslySetInnerHTML: { __html: contentHTML }
	                });
	              }
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-6' },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'container',
	              ref: function ref(divImage) {
	                return _this2.divImage = divImage;
	              }
	            },
	            _react2.default.createElement(_gatsbyImage2.default, { alt: image.title, sizes: image.sizes })
	          )
	        )
	      )
	    );
	  };
	
	  return Intro;
	}(_react2.default.Component);
	
	Intro.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  contentHTML: _propTypes2.default.string.isRequired,
	  image: _propTypes2.default.object.isRequired
	};
	
	exports.default = Intro;
	module.exports = exports['default'];

/***/ }),

/***/ 590:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ = __webpack_require__(427);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Partenaire = function Partenaire(_ref) {
	  var title = _ref.title,
	      list = _ref.list,
	      listIcon = _ref.listIcon,
	      children = _ref.children;
	
	  return _react2.default.createElement(
	    'div',
	    { style: { backgroundColor: '#f5f5f5' } },
	    _react2.default.createElement(
	      'div',
	      { style: { padding: '30px 0 30px 0' }, className: 'container' },
	      _react2.default.createElement(
	        'center',
	        null,
	        _react2.default.createElement(
	          'h3',
	          { style: { fontWeight: 'bold', marginBottom: 20 } },
	          title
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row', style: { marginLeft: 0, marginRight: 0 } },
	      list.map(function (item, i) {
	        var color = void 0;
	        switch (i) {
	          case 0:
	            color = '#085170';
	            break;
	          case 1:
	            color = '#2A8FBA';
	            break;
	          case 2:
	            color = '#1EA8E2';
	            break;
	          default:
	            break;
	        }
	
	        return _react2.default.createElement(
	          'div',
	          {
	            key: item,
	            className: 'col-md',
	            style: { paddingLeft: 0, paddingRight: 0 }
	          },
	          _react2.default.createElement(_.PartenaireCard, { title: item, icon: listIcon[i], color: color })
	        );
	      })
	    )
	  );
	};
	
	Partenaire.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  list: _propTypes2.default.array.isRequired,
	  listIcon: _propTypes2.default.array.isRequired
	};
	
	exports.default = Partenaire;
	module.exports = exports['default'];

/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PartenaireCard = function PartenaireCard(_ref) {
	  var title = _ref.title,
	      icon = _ref.icon,
	      color = _ref.color;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      style: {
	        backgroundColor: color,
	        padding: '50px 0 50px 0',
	        height: '100%'
	      }
	    },
	    _react2.default.createElement(
	      'center',
	      null,
	      _react2.default.createElement(
	        'i',
	        {
	          className: 'material-icons',
	          style: { fontSize: 60, color: 'white', marginBottom: 20 }
	        },
	        icon
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            fontFamily: 'Roboto',
	            fontWeight: 'bold',
	            fontSize: 22,
	            textAlign: 'center',
	            color: '#FFFFFF',
	            overflow: 'hidden'
	          }
	        },
	        title
	      )
	    )
	  );
	};
	
	PartenaireCard.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  icon: _propTypes2.default.string.isRequired,
	  color: _propTypes2.default.string.isRequired
	};
	
	exports.default = PartenaireCard;
	module.exports = exports['default'];

/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _translateTableHead = __webpack_require__(610);
	
	var _translateTableHead2 = _interopRequireDefault(_translateTableHead);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Th = function Th(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'th',
	    { style: { textAlign: 'center' } },
	    children
	  );
	};
	
	Th.propTypes = {
	  children: _propTypes2.default.string
	};
	
	var Td = function Td(_ref2) {
	  var children = _ref2.children;
	  return _react2.default.createElement(
	    'td',
	    { style: { textAlign: 'center' } },
	    children
	  );
	};
	
	Td.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	};
	
	var Tableau = function Tableau(_ref3) {
	  var data = _ref3.data,
	      locale = _ref3.locale;
	
	  if (!data) {
	    return _react2.default.createElement('div', null);
	  }
	
	  var tHead = []; // pour avoir les index des data excel
	  var tHeadStrings = []; // pour avoir les titre des entêtes
	  Object.keys(data[0].node).forEach(function (key) {
	    tHead.push(key);
	    tHeadStrings.push((0, _translateTableHead2.default)(key, locale));
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'container table-responsive table-striped table-hover' },
	    _react2.default.createElement(
	      'table',
	      { className: 'table table-sm' },
	      _react2.default.createElement(
	        'thead',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          tHeadStrings.map(function (title) {
	            return _react2.default.createElement(
	              Th,
	              { key: title },
	              title
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'tbody',
	        null,
	        data.map(function (_ref4, i) {
	          var node = _ref4.node;
	
	          return _react2.default.createElement(
	            'tr',
	            { key: node.modele + '-' + i },
	            tHead.map(function (index) {
	              return _react2.default.createElement(
	                Td,
	                { key: index },
	                node[index]
	              );
	            })
	          );
	        })
	      )
	    )
	  );
	};
	
	Tableau.propTypes = {
	  data: _propTypes2.default.array.isRequired,
	  locale: _propTypes2.default.string.isRequired
	};
	
	exports.default = Tableau;
	module.exports = exports['default'];

/***/ }),

/***/ 427:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Tableau = exports.PartenaireCard = exports.Partenaire = exports.Gamme = exports.Avantages = exports.Intro = undefined;
	
	var _Intro = __webpack_require__(589);
	
	var _Intro2 = _interopRequireDefault(_Intro);
	
	var _Avantages = __webpack_require__(587);
	
	var _Avantages2 = _interopRequireDefault(_Avantages);
	
	var _Gamme = __webpack_require__(588);
	
	var _Gamme2 = _interopRequireDefault(_Gamme);
	
	var _Partenaire = __webpack_require__(590);
	
	var _Partenaire2 = _interopRequireDefault(_Partenaire);
	
	var _PartenaireCard = __webpack_require__(591);
	
	var _PartenaireCard2 = _interopRequireDefault(_PartenaireCard);
	
	var _Tableau = __webpack_require__(592);
	
	var _Tableau2 = _interopRequireDefault(_Tableau);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Intro = _Intro2.default;
	exports.Avantages = _Avantages2.default;
	exports.Gamme = _Gamme2.default;
	exports.Partenaire = _Partenaire2.default;
	exports.PartenaireCard = _PartenaireCard2.default;
	exports.Tableau = _Tableau2.default;

/***/ }),

/***/ 609:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.brandQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(36);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactMedia = __webpack_require__(21);
	
	var _reactMedia2 = _interopRequireDefault(_reactMedia);
	
	var _gatsbyLink = __webpack_require__(25);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _HeaderBanner = __webpack_require__(65);
	
	var _HeaderBanner2 = _interopRequireDefault(_HeaderBanner);
	
	var _brand = __webpack_require__(427);
	
	var _ContactUs = __webpack_require__(50);
	
	var _ContactUs2 = _interopRequireDefault(_ContactUs);
	
	var _Buttons = __webpack_require__(576);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BrandTemplate = function BrandTemplate(_ref) {
	  var _ref$data = _ref.data,
	      contentfulBrandPage = _ref$data.contentfulBrandPage,
	      contentfulAboutPage = _ref$data.contentfulAboutPage,
	      allGammesXlsxCaterpillar = _ref$data.allGammesXlsxCaterpillar,
	      allGammesXlsxMercury = _ref$data.allGammesXlsxMercury,
	      allGammesXlsxYanmar = _ref$data.allGammesXlsxYanmar,
	      allGammesXlsxKohler = _ref$data.allGammesXlsxKohler;
	
	  var brandName = contentfulBrandPage.brandName === 'Kohler' ? 'Köhler' : contentfulBrandPage.brandName;
	  var headerImage = contentfulAboutPage.headerImage;
	
	  var introTitle = contentfulBrandPage.introTitle;
	  var introContent = contentfulBrandPage.introContent.childMarkdownRemark.html;
	  var introImage = contentfulBrandPage.introImage;
	
	  var avantagesTitle = contentfulBrandPage.avantagesTitle;
	  var avantagesContent = contentfulBrandPage.avantagesContent.childMarkdownRemark.html;
	  var avantagesImage = contentfulBrandPage.avantagesImage;
	
	  var gammeTitle = contentfulBrandPage.gammeTitle;
	
	  var partenaireTitle = contentfulBrandPage.partenaireTitle;
	  var partenaireList = contentfulBrandPage.partenaireList;
	  var partenaireListIcon = contentfulBrandPage.partenaireListIcon;
	
	  var locale = contentfulBrandPage.node_locale;
	
	  var extLink = contentfulBrandPage.extLink;
	
	  // Excel data
	  // * depends of the brandName
	  var excelData = void 0;
	
	  switch (contentfulBrandPage.brandName.toLowerCase()) {
	    case 'caterpillar':
	      excelData = allGammesXlsxCaterpillar.edges;
	      break;
	    case 'mercury/mercruiser':
	      excelData = allGammesXlsxMercury.edges;
	      break;
	    case 'yanmar':
	      excelData = allGammesXlsxYanmar.edges;
	      break;
	    case 'kohler':
	      excelData = allGammesXlsxKohler.edges;
	      break;
	    default:
	      break;
	  }
	
	  var hreflang = contentfulBrandPage.node_locale === 'fr' ? 'en' : 'fr';
	  var alternatePath = contentfulBrandPage.brandName.toLowerCase() === 'mercury/mercruiser' ? 'mercury-mercruiser' : contentfulBrandPage.brandName.toLowerCase();
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement('html', { lang: contentfulBrandPage.node_locale }),
	      _react2.default.createElement(
	        'title',
	        null,
	        'Offshore Services - ' + brandName
	      ),
	      _react2.default.createElement('meta', {
	        name: 'description',
	        content: contentfulBrandPage.metaDescription
	      }),
	      _react2.default.createElement('link', {
	        rel: 'alternate',
	        hreflang: hreflang,
	        href: 'https://www.offshoreservices.fr/' + hreflang + '/' + alternatePath + '/'
	      })
	    ),
	    _react2.default.createElement(
	      _reactMedia2.default,
	      { query: { minWidth: 768 } },
	      function (matches) {
	        return matches ? _react2.default.createElement(
	          'div',
	          { style: { marginBottom: 195 } },
	          _react2.default.createElement(_HeaderBanner2.default, { title: brandName, image: headerImage })
	        ) : _react2.default.createElement(
	          'div',
	          { style: { marginBottom: 215 } },
	          _react2.default.createElement(_HeaderBanner2.default, { title: brandName, image: headerImage })
	        );
	      }
	    ),
	    _react2.default.createElement(_brand.Intro, { title: introTitle, contentHTML: introContent, image: introImage }),
	    _react2.default.createElement(_brand.Avantages, {
	      title: avantagesTitle,
	      contentHTML: avantagesContent,
	      image: avantagesImage
	    }),
	    _react2.default.createElement(_brand.Gamme, { title: gammeTitle }),
	    _react2.default.createElement(_brand.Tableau, { data: excelData, locale: locale }),
	    _react2.default.createElement(
	      'center',
	      { style: { marginBottom: 15 } },
	      _react2.default.createElement(_Buttons.LinkButton, {
	        text: locale === 'fr' ? 'Consultez le site officiel' : 'Visite the official website',
	        to: extLink,
	        isExternal: true
	      })
	    ),
	    _react2.default.createElement(_brand.Partenaire, {
	      title: partenaireTitle,
	      list: partenaireList,
	      listIcon: partenaireListIcon
	    }),
	    _react2.default.createElement(_ContactUs2.default, { locale: locale })
	  );
	};
	
	exports.default = BrandTemplate;
	var brandQuery = exports.brandQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 610:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var translateTableHead = function translateTableHead(headTitle, locale) {
	  /**
	   * Fonction qui récupère l'entête des tableau Excel
	   * et qui retourne une traduction et un 'format' adapté
	   */
	
	  var newHead = void 0;
	
	  switch (headTitle) {
	    case 'modele':
	      newHead = locale === 'fr' ? 'Modèle' : 'Model';
	      break;
	    case 'cylindree':
	      newHead = locale === 'fr' ? 'Cylindrée' : 'Displacement';
	      break;
	    case 'puissance_administrative':
	      newHead = locale === 'fr' ? 'Puissance Administrative' : 'Administrative Power';
	      break;
	    case 'puissance_cv':
	      newHead = locale === 'fr' ? 'Puissance (cv)' : 'Power (hp)';
	      break;
	    case 'puissance_kw':
	      newHead = locale === 'fr' ? 'Puissance (kW)' : 'Power (kW)';
	      break;
	    case 'vitesse_de_rotation':
	      newHead = locale === 'fr' ? 'Vitesse de Rotation (tr/min)' : 'Speed Rate (rpm)';
	      break;
	    case 'frequence':
	      newHead = locale === 'fr' ? 'Frequence (Hz)' : 'Frequency (Hz)';
	      break;
	    case 'puissance_fournie':
	      newHead = locale === 'fr' ? 'Puissance de Sortie (kW)' : 'Output Power (kW)';
	      break;
	    case 'nb_cyl':
	      newHead = locale === 'fr' ? 'Nombre de cylindre' : 'Number of cylinder';
	      break;
	    case 'transmission':
	      newHead = locale === 'fr' ? 'Type de Transmission' : 'Transmission';
	      break;
	    case 'poids':
	      newHead = locale === 'fr' ? 'Poids (kg)' : 'Weight (kg)';
	      break;
	    default:
	      newHead = headTitle;
	      break;
	  }
	
	  return newHead;
	};
	
	exports.default = translateTableHead;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-brand-js-a2e5fc194966da08ed4f.js